import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MigrationModalState {
  active: boolean;
}

const initialState: MigrationModalState = {
  active: false,
};

const migrationModalSlice = createSlice({
  name: 'migrationModal',
  initialState,
  reducers: {
    setMigrationModalActive(state, action: PayloadAction<boolean>) {
      state.active = action.payload;
    },
    openMigrationModal(state) {
      state.active = true;
    },
    closeMigrationModal(state) {
      state.active = false;
    },
  },
});

export const { setMigrationModalActive, openMigrationModal, closeMigrationModal } = migrationModalSlice.actions;

export default migrationModalSlice.reducer; 